/* DRIVE IQ — ADVENTURE MODE V600 UTILS
   File: adventure-utils.js
*/
(function(window){
"use strict";

if(window.DriveIQAdventureUtils){return;}

function byId(id){return document.getElementById(id);}
function qs(s,r){return (r||document).querySelector(s);}
function qsa(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));}
function clean(v){return String(v==null?"":v).trim();}
function normText(v){return clean(v).toLowerCase().replace(/\s+/g," ");}
function finite(v,f){v=Number(v);return Number.isFinite(v)?v:f;}
function clamp(v,min,max){return Math.min(max,Math.max(min,v));}
function safeParse(t,f){try{return JSON.parse(t);}catch(e){return f;}}
function lsSet(k,v){try{localStorage.setItem(k,v);}catch(e){}}
function lsGet(k,f){try{var v=localStorage.getItem(k);return v==null?f:v;}catch(e){return f;}}
function lsJSON(k,f){return safeParse(lsGet(k,""),f);}
function lsRemove(k){try{localStorage.removeItem(k);}catch(e){}}
function escapeHTML(s){
 return clean(s).replace(/[&<>"']/g,function(c){
  return({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]);
 });
}
function titleCaseWords(s){
 return clean(s).toLowerCase().replace(/\b\w/g,function(c){return c.toUpperCase();});
}
function distanceMiles(aLat,aLng,bLat,bLng){
 var R=6371000;
 var p=Math.PI/180;
 var dLat=(bLat-aLat)*p,dLng=(bLng-aLng)*p;
 var aa=Math.sin(dLat/2)**2+Math.cos(aLat*p)*Math.cos(bLat*p)*Math.sin(dLng/2)**2;
 return (R*2*Math.atan2(Math.sqrt(aa),Math.sqrt(1-aa)))/1609.344;
}
function uuid(){
 return"diq-"+Date.now().toString(36)+"-"+Math.random().toString(36).slice(2,10);
}
window.DriveIQAdventureUtils={
 byId,qs,qsa,clean,normText,finite,clamp,safeParse,
 lsSet,lsGet,lsJSON,lsRemove,
 escapeHTML,titleCaseWords,distanceMiles,uuid
};
console.log("[Drive IQ Adventure V600] Utils loaded");
})(window);
